// extracted by mini-css-extract-plugin
module.exports = {"emptyStateWrapper":"emptyState_emptyStateWrapper__RCLh9","headline":"emptyState_headline__jiRLZ","subhead":"emptyState_subhead__jw5uv"};